<template>
  <v-dialog :value="true" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline">Подтверждение аккаунта Telegram</v-card-title>

      <v-card-text class="d-flex flex-column" style="gap: 1.5rem">
        <span>
          Для подключения Telegram аккаунта к личному кабинету необходимо подтвердить дополнительным ключом, он будет отправлен в Telegram после нажатия кнопки ниже.
        </span>

        <v-btn v-if="!keySended" color="primary" @click="sendKey">Отправить ключ</v-btn>
        <v-text-field v-else
          v-model="keyInput"
          dense
          single-line
          hide-details="auto"
          outlined
          label="Ключ подтверждения"
          hint="Введите в это поле полученный ключ для подтверждения аккаунта"
          persistent-hint
        >
          <template #append-outer>
            <v-btn color="accent" text :disabled="keyInput.length < 8" @click="confirmKey">Подтвердить</v-btn>
          </template>
        </v-text-field>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import server from '@/api/server';

export default {
  props: {
    telegramSession: {
      type: String,
      required: true,
    }
  },

  data: () => ({
    keySended: false,
    keyInput: '',
  }),

  methods: {
    async sendKey() {
      const response = await server.post('agent/agent/telegram/confirm', {
        session_id: this.telegramSession
      });

      if (response) {
        this.keySended = true;
      }
    },

    async confirmKey() {
      const response = await server.post('agent/agent/telegram/confirm', {
        session_id: this.telegramSession,
        confirm_key: this.keyInput
      });

      if (response) {
        this.$router.replace({ query: {} });
      }
    }
  },
}
</script>
